import { withInstall } from '../utils/type';
import StepinView from './StepinView.js';
import StepinViewPlugin from './stepin-view-plugin';
import { StepinHeaderAction } from './stepin-header';
export { StepinHeaderAction } from './stepin-header';
export default withInstall(StepinView, StepinViewPlugin, StepinHeaderAction);